"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Eyepatch_1 = require("./Eyepatch");
var GlassRoundThick_1 = require("./GlassRoundThick");
var SunglassClubmaster_1 = require("./SunglassClubmaster");
var SunglassWayfarer_1 = require("./SunglassWayfarer");
var GlassAviator_1 = require("./GlassAviator");
var GlassButterfly_1 = require("./GlassButterfly");
var GlassButterflyOutline_1 = require("./GlassButterflyOutline");
var GlassClubmaster_1 = require("./GlassClubmaster");
var GlassRound_1 = require("./GlassRound");
var None_1 = require("./None");
exports.Accessories = {
    None: None_1.None,
    Eyepatch: Eyepatch_1.Eyepatch,
    GlassRoundThick: GlassRoundThick_1.GlassRoundThick,
    SunglassClubmaster: SunglassClubmaster_1.SunglassClubmaster,
    SunglassWayfarer: SunglassWayfarer_1.SunglassWayfarer,
    GlassAviator: GlassAviator_1.GlassAviator,
    GlassButterfly: GlassButterfly_1.GlassButterfly,
    GlassButterflyOutline: GlassButterflyOutline_1.GlassButterflyOutline,
    GlassClubmaster: GlassClubmaster_1.GlassClubmaster,
    GlassRound: GlassRound_1.GlassRound
};
//# sourceMappingURL=z_options.js.map